import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class LogicQuotient extends DesigntimeComponent {
    static staticName = "Logic: Quotient";
    static staticId = "logicQuotient";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {};

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 },
            parameter2: { key: "url:monthlySpending", value: 1 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicQuotient'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (eventParams.key == this.params.parameter1.key)
            this.params.parameter1.value = eventParams.value;
        else if (eventParams.key == this.params.parameter2.key)
            this.params.parameter2.value = eventParams.value;
        else
            return;

        var quotient = this.params.parameter1.value / this.params.parameter2.value;
        this.eventBroker.fireValueChanged(this.id, "quotient", quotient);
        this.eventBroker.fireValueChanged(this.id, "quotient_x", componentHelpers.round(quotient, 1));
        this.eventBroker.fireValueChanged(this.id, "quotient_xx", componentHelpers.round(quotient, 2));
    }

    output = [
        { name: "quotient", type: "number" },
        { name: "quotient_x", type: "number" },
        { name: "quotient_xx", type: "number" }
    ];
}

export { LogicQuotient }
